import {
  promoCodeDetailSchema,
  promoCodeSchema,
  promoCodesResponseSchema,
  type PromoCode,
  type PromoCodeCreateRequest,
  type PromoCodeDetail,
  type PromoCodesResponse,
  type PromoCodeUpdateRequest,
} from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

export const fetchPromoCodes = (signal?: AbortSignal): Promise<PromoCodesResponse> =>
  apiRequest('/promo-codes', { schema: promoCodesResponseSchema, signal })

export const fetchPromoCode = (id: number, signal?: AbortSignal): Promise<PromoCodeDetail> =>
  apiRequest(`/promo-codes/${id}`, { schema: promoCodeDetailSchema, signal })

export const createPromoCode = (request: PromoCodeCreateRequest): Promise<PromoCode> =>
  apiRequest('/promo-codes', { method: 'POST', body: request, schema: promoCodeSchema })

export const updatePromoCode = (id: number, request: PromoCodeUpdateRequest): Promise<PromoCode> =>
  apiRequest(`/promo-codes/${id}`, { method: 'PATCH', body: request, schema: promoCodeSchema })
